import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

let initZoom = 1;

class Map extends PureComponent {
    static propTypes = {
        mapReRender: PropTypes.bool,
        data: PropTypes.array,
        handleMapReRender: PropTypes.func,
        handleMapReRenderStop: PropTypes.func,
        updateTime: PropTypes.string
    };

    echarts = null;
    map = null;
    extraMap = null;

    nameMap = {};
    countryMap = {};
    cityArr = [];

    async componentDidMount() {
        // 引入 ECharts 主模块
        this.echarts = await import('echarts/lib/echarts');

        // 引入世界地图
        await import('echarts/map/js/world');
        // 引入提示框和标题组件
        await import('echarts/lib/component/tooltip');

        this.nameMap = await import('./name/USA');

        this.nameMap = this.nameMap.default;

        this.countryMap = await import('./json/USA');

        this.countryMap = this.countryMap.default;

        this.cityArr = this.countryMap.features.map(item => this.nameMap[item.properties.name] || '');

        this.mapRender(1);
    }

    componentDidUpdate(prevProps) {
        const { mapReRender, handleMapReRenderStop } = this.props;

        if (mapReRender && !prevProps.mapReRender) {
            this.mapRender(1);

            handleMapReRenderStop();
        }
    }

    mapRender = async (zoom, roam) => {
        console.log('mapReder ==== ');

        if (this.map) {
            this.map.dispose();
        }

        this.map = this.echarts.init(document.getElementById('world'));

        this.echarts.registerMap('worldCity', this.countryMap, {
            Alaska: {
                left: -131,
                top: 27,
                width: 15,
            },
            Hawaii: {
                left: -110,
                top: 24,
                width: 7,
            },
        });

        const mapData = this.cityArr.map(item => this.getAreaData(item));

        const extra = {
            top: 20,
            left: 0,
            right: 20,
            bottom: 20,
        };

        const worldSeries = [
            {
                name: '世界',
                type: 'map',
                mapType: 'worldCity',
                roam,
                zoom,
                scaleLimit: {
                    max: 5,
                    min: 1,
                },
                ...extra,
                itemStyle: {
                    normal: {
                        borderColor: '#E2B2B2', // 边框颜色
                        borderWidth: 0.5, // 边框线宽
                    },
                },
                label: {
                    show: false,
                },
                data: mapData,
                nameMap: this.nameMap,
            },
        ];

        const option = {
            tooltip: {
                trigger: 'item',
                showDelay: 0,
                enterable: true,
                transitionDuration: 0.2,
                padding: 10,
                borderWidth: 1,
                position: ['35%', '80%'],
                extraCssText: 'background:rgba(0,0,0,0.8);box-shadow: 0px 0px 4px 0px rgba(219,219,219,0.5);',
                textStyle: {
                    color: '#FFFFFF',
                    padding: 5,
                },
                formatter: params => {
                    if (params.data) {
                        const {
                            name,
                            bidenNum,
                            trumpNum,
                            bidenSum,
                            trumpSum,
                            bidenRate,
                            trumpRate,
                            status,
                        } = params.data.num;

                        if (!name) return '';

                        let result = `<div class=${styles.name_box}>${name}</div>`;

                        result += `<div class=${styles.trump_box}>
                                    <img class=${styles.num_face} src="https://x0.ifengimg.com/ucms/2024_45/A36043044AA3E41CB5EB2447B506FDC7BD843106_size8_w72_h72.png" />
                                    <span>特朗普</span>
                                    <div class=${styles.num_wrapper}>
                                        <div class=${styles.num_box}>
                                            <span id="trump_num"></span>
                                            <div class=${styles.num}>
                                                <span>${trumpSum}</span>
                                                <span>${trumpRate}%</span>
                                            </div>
                                        </div>
                                        ${status === '已结束' && trumpNum > bidenNum ? '<i></i>' : ''}
                                    </div>
                                </div>`;

                        result += `<div class=${styles.biden_box}>
                                    <img class=${styles.num_face} src="https://x0.ifengimg.com/ucms/2024_45/9AB863BC3E6A1981ACFC500817E70A04447CA919_size9_w72_h72.png" />
                                    <span>哈里斯</span>
                                    <div class=${styles.num_wrapper}>
                                        <div class=${styles.num_box}>
                                            <span id="biden_num"></span>
                                            <div class=${styles.num}>
                                                <span>${bidenSum}</span>
                                                <span>${bidenRate}%</span>
                                            </div>
                                        </div>
                                        ${status === '已结束' && bidenNum > trumpNum ? '<i></i>' : ''}
                                    </div>
                                </div>`;

                        return result;
                    }

                    return '';
                },
            },
            series: worldSeries,
        };

        this.map.setOption(option);

        this.map.on('click', params => {
            if (params.data) {
                const { bidenRate, trumpRate } = params.data.num;

                /* eslint-disable no-undef */
                TweenLite.fromTo(
                    '#biden_num',
                    0.4,
                    { width: 0 },
                    {
                        width: `${bidenRate}%`,
                    },
                );

                TweenLite.fromTo(
                    '#trump_num',
                    0.4,
                    { width: 0 },
                    {
                        width: `${trumpRate}%`,
                    },
                );
                /* eslint-enable no-undef */
            }
        });
    };

    getAreaData = name => {
        const { data } = this.props;

        let areaObj = {
            name,
            itemStyle: {
                normal: {
                    areaColor: '#DDDDDD',
                },
            },
            num: {},
        };

        data.every(item => {
            if (name.indexOf(item.name) === 0) {
                const bidenNum = item.bidenNum;
                const trumpNum = item.trumpNum;
                const bidenSum = item.bidenSum;
                const trumpSum = item.trumpSum;
                const bidenRate = item.bidenRate;
                const trumpRate = item.trumpRate;

                const status = item.status;
                const name = item.name.includes('华盛顿哥伦比亚特区') ? item.name : `${item.name}州`;

                areaObj = {
                    ...areaObj,
                    itemStyle: {
                        normal: {
                            areaColor: this.getColor({
                                bidenNum,
                                trumpNum,
                                bidenSum,
                                trumpSum,
                                status,
                            }),
                        },
                    },
                    num: {
                        name: `${name}-${item.id} / ${item.voteSum} (选举人票)`,
                        bidenNum: status === '未开始' ? 0 : bidenNum,
                        trumpNum: status === '未开始' ? 0 : trumpNum,
                        bidenSum: status === '未开始' ? 0 : bidenSum,
                        trumpSum: status === '未开始' ? 0 : trumpSum,
                        bidenRate: status === '未开始' ? 0 : bidenRate,
                        trumpRate: status === '未开始' ? 0 : trumpRate,
                        status: item.status,
                    },
                };

                return false;
            }

            return true;
        });

        return areaObj;
    };

    getColor = ({ bidenNum, trumpNum, bidenSum, trumpSum, status }) => {
        if (status === '未开始') return '#DDDDDD';

        if (!bidenNum && !trumpNum) {
            if (bidenSum > trumpSum) return status === '已结束' ? '#0257A0' : '#73ACFF';
            if (trumpSum > bidenSum) return status === '已结束' ? '#CA1D2A' : '#FF6F6F';
        } else {
            if (bidenNum > trumpNum) return status === '已结束' ? '#0257A0' : '#73ACFF';
            if (trumpNum > bidenNum) return status === '已结束' ? '#CA1D2A' : '#FF6F6F';
        }

        return '#DDDDDD';
    };

    handleRefresh = () => {
        this.props.handleMapReRender();

        /* eslint-disable no-undef */
        TweenLite.fromTo(
            '#refresh_btn',
            1,
            { rotation: 0 },
            {
                rotation: 360,
            },
        );
        /* eslint-enable no-undef */
    };

    handleReset = () => {
        initZoom = 1;

        this.mapRender(initZoom);
    };

    handleZoomIn = () => {
        if (initZoom === 5) {
            return;
        }

        initZoom++;

        this.mapRender(initZoom, true);
    };

    handleZoomOut = () => {
        if (initZoom === 1) {
            return;
        }

        initZoom--;

        this.mapRender(initZoom, initZoom > 1);
    };

    render() {
        return (
            <div className={styles.box}>
                <div className={styles.title}>
                    <span className={styles.title1}>选举地图</span>
                    <span className={styles.title2}>数据截至：{this.props.updateTime}</span>
                    <span onClick={this.handleRefresh} className={styles.title3}>
                        <span id="refresh_btn" />
                        <span>手动刷新</span>
                    </span>
                </div>
                <div id="world" className={styles.map} />
                <div className={styles.btn_box}>
                    <span onClick={this.handleReset}>重置</span>
                    <span onClick={this.handleZoomIn}>+</span>
                    <span onClick={this.handleZoomOut}>-</span>
                </div>
                <div className={styles.bar_box} />
            </div>
        );
    }
}

export default errorBoundary(Map);
